import { render, staticRenderFns } from "./Shared.vue?vue&type=template&id=83c5884c&"
import script from "./Shared.vue?vue&type=script&lang=js&"
export * from "./Shared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83c5884c')) {
      api.createRecord('83c5884c', component.options)
    } else {
      api.reload('83c5884c', component.options)
    }
    module.hot.accept("./Shared.vue?vue&type=template&id=83c5884c&", function () {
      api.rerender('83c5884c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Access/Shared/Shared.vue"
export default component.exports